import { Control, Field, TextArea } from "@allxsmith/bestax-bulma";
import React from "react";
import useInlineEditButton from "./useInlineEditButton";

function useEditableTableTextAreaCell({
  propName,
  value,
  onChange,
  onSave,
  editable,
  setEditable,
  disabled,
  inlineEdit,
  doubleWide
}) {
  const styles = `small-row-black ${doubleWide ? "double-wide-textarea" : "min-column-width"}`;
  return (
    <td onClick={e => e.stopPropagation()}>
      <Field className="has-addons">
        <Control>
          <TextArea
            rows={2}
            className={styles}
            onChange={onChange}
            type="text"
            name={propName}
            value={value}
            disabled={!editable}
          />
        </Control>
        {useInlineEditButton({show: inlineEdit, onSave, disabled, setEditable, editable})}
      </Field>
    </td>
  );
}

export default useEditableTableTextAreaCell;
